import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUpload, faFileMedical, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { forwardRef, useState } from "react";

const FileToggle = forwardRef(({ onClick }, ref) => {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      ref={ref}
      onClick={(e) => { e.preventDefault(); onClick(e); }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "inline-flex", alignItems: "center", gap: "6px",
        padding: "7px 12px",
        background: hovered ? "#dce8fc" : "#e8f0fe",
        color: "#1a73e8",
        border: "none", borderRadius: "8px",
        fontWeight: 600, fontSize: "0.82rem",
        cursor: "pointer", transition: "background 0.15s",
      }}
    >
      <FontAwesomeIcon icon={faFileMedical} />
      Files
      <FontAwesomeIcon icon={faChevronDown} style={{ fontSize: "0.65rem", opacity: 0.7 }} />
    </button>
  );
});

const DocumentConnectionButtons = ({ showUpload, showLink }) => (
  <Dropdown>
    <Dropdown.Toggle as={FileToggle} />
    <Dropdown.Menu style={{
      borderRadius: "10px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
      border: "1px solid #f0f0f0",
      padding: "6px",
      minWidth: "140px",
      marginTop: "4px",
    }}>
      <Dropdown.Item as="div" onClick={() => showUpload(true)} style={{
        display: "flex", alignItems: "center", gap: "10px",
        padding: "8px 12px", borderRadius: "7px",
        fontSize: "0.88rem", fontWeight: 500, color: "#424242", cursor: "pointer",
      }}>
        <span style={{
          width: "26px", height: "26px", borderRadius: "6px",
          background: "#e8f0fe", color: "#1a73e8",
          display: "flex", alignItems: "center", justifyContent: "center", fontSize: "0.75rem",
        }}>
          <FontAwesomeIcon icon={faUpload} />
        </span>
        Upload
      </Dropdown.Item>

      {typeof showLink !== "undefined" && (
        <>
          <div style={{ height: "1px", background: "#f5f5f5", margin: "4px 0" }} />
          <Dropdown.Item as="div" onClick={() => showLink(true)} style={{
            display: "flex", alignItems: "center", gap: "10px",
            padding: "8px 12px", borderRadius: "7px",
            fontSize: "0.88rem", fontWeight: 500, color: "#424242", cursor: "pointer",
          }}>
            <span style={{
              width: "26px", height: "26px", borderRadius: "6px",
              background: "#e8f5e9", color: "#2e7d32",
              display: "flex", alignItems: "center", justifyContent: "center", fontSize: "0.75rem",
            }}>
              <FontAwesomeIcon icon={faPlus} />
            </span>
            Add
          </Dropdown.Item>
        </>
      )}
    </Dropdown.Menu>
  </Dropdown>
);

export default DocumentConnectionButtons;
